import {client} from '../helpers/api';

function getTransactionDetails(inputData) {
  if (!inputData) {
    return undefined;
  }

  const {
    _kid_id: kidId,
    _package_id: packageId,
    date_created: dateCreated,
    payment_status: paymentStatus,
    payment_type: paymentType,
    subject_names: subjectNames,
    transaction_id: transactionId,
    no_of_subject: noOfSubject,
    total_price: totalPrice,
    price_per_subject: pricePerSubject,
  } = inputData;

  const res = {
    kidId,
    packageId,
    dateCreated,
    paymentStatus,
    paymentType,
    subjectNames,
    transactionId,
    noOfSubject,
    totalPrice,
    pricePerSubject,
  };

  return res;
}

export async function getKids() {
  const response = await client.get('/api/kids');

  if (response.data?.status) {
    const mergedData =
      response.data?.data.kids.map(
        ({
          kid_id: id,
          _user_id: userId,
          _package_id: packageId,
          package_start_date: packageStartDate,
          package_exp_date: packageExpDate,
          student_name: name,
          gender,
          kids_image: kidsImage,
          grade: gradeId,
          dob,
          _transaction_id: transactionId,
        }) => ({
          id,
          userId,
          packageId,
          packageStartDate,
          packageExpDate,
          name,
          gender,
          gradeId,
          dob,
          kidsImage,
          transactionId,
          transactionDetails: getTransactionDetails(
            response.data.data.transactions.find(
              (transaction) => transaction.transaction_id === transactionId,
            ),
          ),
        }),
      ) || [];

    return mergedData;
  }
  throw response;
}

// {
//   "kid_id": "e6cfdf51-d611-4bbc-89b2-fd934d4a183e",
//   "_user_id": "51438d73-041e-49b0-95a7-c74bc5b15967",
//   "_package_id": "1082e459-9788-479a-9c59-5806457769eb",
//   "package_start_date": "2021-01-14",
//   "package_exp_date": "2021-03-14",
//   "student_name": "Manish Singh",
//   "gender": "Boy",
//   "ic_number": null,
//   "grade": "c6e482fb-e36b-4cc0-bd45-acaaf0f53723",
//   "dob": "2021-01-12T09:47:55.962Z",
//   "date_created": "2021-01-12 09:48:42",
//   "date_modified": "2021-01-14 23:04:56",
//   "status": "active",
//   "is_deleted": 0,
//   "_transaction_id": "0027d078-2440-4542-9f36-0010ef001081"
// }

// {
//   _kid_id: 'e6cfdf51-d611-4bbc-89b2-fd934d4a183e',
//   _package_id: '1082e459-9788-479a-9c59-5806457769eb',
//   approved_by: '3935d44b-0748-4ce5-bbfc-6be5f373e2f5',
//   date_created: '2021-01-17 11:54:50',
//   date_modified: '2021-01-19 00:30:24',
//   is_deleted: 0,
//   no_of_subject: 2,
//   notes: '',
//   payment_gateway_id: null,
//   payment_image: 'shutterstock.jpg',
//   payment_status: 'success',
//   payment_txn_id: null,
//   payment_type: 'manual',
//   price_per_subject: 40,
//   status: 'active',
//   subject_names: null,
//   total_price: 80,
//   transaction_id: '1fa6ff6d-2182-4975-8dea-bc2972cc5a5d',
// };
